import script from "./skip-previous-icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./skip-previous-icon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__